var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useState } from 'react';
export const useCallbackRefState = () => {
    _react_refresh_temp_1();
    const [refValue, setRefValue] = useState(null);
    const refCallback = useCallback((value) => setRefValue(value), []);
    return [refValue, refCallback];
};
_react_refresh_temp_1(useCallbackRefState, "vBN3ljNIb8eWRbWq9RZvFD71byw=");
